import React from "react";

function Left() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="340"
            height="220"
            fill="none"
            viewBox="0 0 340 220"
        >
            <path
                stroke="#5479F7"
                strokeDasharray="1 7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M339 219c-5.31-70.257-63.487-109.218-174.532-116.882C53.423 94.455-1.046 60.748 1.058 1"
            ></path>
        </svg>
    );
}

export default Left;
